import styles from './Select.module.scss';

const Select = ({children, name, defaultValue, onChange, disabled=false, theme=""}) => {

    return ( 
        <div className={`${styles.select} ${disabled ? styles["select-disabled"] : ""} ${styles[`select-${theme!=="" ? theme : 'main'}`]}`}>
            <select name={name}  value={defaultValue} onChange={(e)=>onChange(e.target.value)} disabled={disabled}>
                {children}
            </select>
        </div>
     );
}
 
export default Select;